import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconEnlarge$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEnlarge extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f8f2e6902b1c50adec9300ea7e0aa2a4c67ea8a1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '81ab28325596883677132384f5b4e3cfc17f5967', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7066ab03dd2e31b07f2de6711fa2abc95d222888', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.966 4H17.6c.22 0 .4.18.4.4v4.634a.4.4 0 0 1-.678.288l-1.778-1.778-2.637 2.638a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707l2.636-2.638-1.8-1.8A.4.4 0 0 1 12.966 4M6.48 14.48l2.655-2.657a.5.5 0 0 1 .712 0l.353.354a.5.5 0 0 1 0 .707l-2.659 2.657 1.776 1.776a.4.4 0 0 1-.283.683H4.4a.4.4 0 0 1-.4-.4v-4.634a.4.4 0 0 1 .68-.286z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-enlarge", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-enlarge"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-enlarge":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEnlarge$1);
            }
            break;
    } });
}

const CosmosIconEnlarge = CosmosIconEnlarge$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEnlarge, defineCustomElement };
